const tprElements = document.querySelectorAll('.tpr');
setTimeout(() => {
    tprElements.forEach(tprElement => {
        tprElement.classList.remove('invisible');
        setTimeout(() => {
            const loader = tprElement.querySelector('.tpr__loader');
            if (loader) {
                loader.remove();
            }
            const stars = tprElement.querySelector('.tpr__stars');
            if (stars) {
                stars.classList.remove('mf-hide');
            }
        }, 600);
    })
}, 600);
